const Spinner = () => {
  return <div className="spinner" />;
};

export default Spinner;
